export const commonStyles = (FOUNDATIONS) => ({
    container: {
        display: 'flex',
        flex_direction: 'column',
        width: '100%',
        height: 'auto',
        margin_top: FOUNDATIONS.spacing_50,
        gap: FOUNDATIONS.spacing_250,
    },
    row: {
        display: 'flex',
        width: '100%',
        align_items: 'flex-start',
        gap: FOUNDATIONS.spacing_150,
    },
});
//# sourceMappingURL=commonStyles.js.map